/**
 * 用户信息 Store
 * 统一管理用户状态，替代 useUserInfo Hook
 */

import { create } from 'zustand';
import wetvKernel from '@tencent/wetv-kernel';

export interface UserInfo {
  /** 用户ID */
  uid?: string;
  /** 语言设置 */
  lang?: string;
  /** 是否登录 */
  isLogin?: boolean;
  /** 用户头像 URL */
  avatar?: string;
  /** 用户昵称 */
  nick?: string;
  /** 主登录方式 */
  mainLogin?: string;
  [key: string]: any;
}

interface UserInfoStoreState {
  userInfo: UserInfo | null;
  isInitialized: boolean;
}

interface UserInfoStoreActions {
  /** 刷新用户信息（从 wetvKernel 读取） */
  refresh: () => void;
  /** 直接设置用户信息（用于登录后立即更新，不等待 kernel 同步） */
  setUserInfo: (userInfo: UserInfo) => void;
  /** 初始化用户信息 */
  init: () => void;
  /** 重置用户信息到初始状态 */
  reset: () => void;
}

type UserInfoStore = UserInfoStoreState & UserInfoStoreActions;

// 初始状态
const initialState: UserInfoStoreState = {
  userInfo: null,
  isInitialized: false,
};

export const useUserInfoStore = create<UserInfoStore>((set, get) => ({
  ...initialState,

  // 刷新用户信息
  refresh: () => {
    const { user } = wetvKernel;

    if (!user) {
      set({ userInfo: null });
      return;
    }

    set({
      userInfo: {
        uid: user.uid,
        lang: user.lang,
        isLogin: user.isLogin,
        avatar: user.avatar,
        nick: user.nick,
        mainLogin: user.mainLogin,
      },
    });
  },

  // 直接设置用户信息（登录后立即更新）
  setUserInfo: (userInfo: UserInfo) => {
    set({ userInfo });
  },

  // 初始化
  init: () => {
    if (get().isInitialized) {
      return;
    }
    // 首次加载用户信息
    get().refresh();
    set({ isInitialized: true });
  },

  // 重置到初始状态
  reset: () => {
    set(initialState);
  },
}));
